import { Suspense, useContext } from 'react';

import { Outlet } from '@spazious/dollhouse-router';
import {
  DraggableContext,
  ErrorBoundary,
  MainLayout,
  useDeviceInfo,
} from '@spazious/dollhouse-shared';
import { Flex, Spinner } from '@spazious/dollhouse-uikit';

import { Dollhouse } from '../Dollhouse/index.js';
import { Notifier } from '../Notifier/index.js';
import { SideBar as SideBarDesktop } from '../SideBar/index.js';
import { SideBarMobile } from '../SideBarMobile/index.js';

import { MainContext } from './MainContext.js';

export interface MainProps {}

type AsidePosition = 'bottom' | 'left'; // 'top' and 'right' have not been implemented

export const Main: React.FC<MainProps> = () => {
  const { isMobile, isPortrait } = useDeviceInfo();

  const asidePosition: AsidePosition = isMobile && isPortrait ? 'bottom' : 'left';
  const SideBar = isMobile ? SideBarMobile : SideBarDesktop;

  return (
    <ErrorBoundary>
      <DraggableContext>
        <MainLayout
          aside={
            <SideBar>
              <Suspense
                fallback={
                  <Flex column grow alignItems="center" justifyContent="center">
                    <Spinner />
                  </Flex>
                }
              >
                <Outlet />
              </Suspense>
            </SideBar>
          }
          asidePosition={asidePosition}
          backdrop={<Dollhouse />}
        >
          {useContext(MainContext)}
          <Notifier />
        </MainLayout>
      </DraggableContext>
    </ErrorBoundary>
  );
};
